(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sportinfo/configs/assets/javascripts/inject-tab.js') >= 0) return;  svs.modules.push('/components/sportinfo/configs/assets/javascripts/inject-tab.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const {
  matchState: {
    SportinfoMatchState: MatchState
  },
  constants: {
    SportinfoPathNames,
    SvsViewType
  }
} = svs.components.sportinfo.common;
const {
  ContentProvider
} = svs.components.sportinfo.common.constants;
const {
  ConfigBuilder
} = svs.components.sportinfo.configBuilder;
const injectAnalyze = (menuItems, content, matchState) => {
  const {
    menuItems: analyzeMenuItems,
    content: analyzeContent
  } = new ConfigBuilder().addTab(SportinfoPathNames.Analyze, tab => {
    tab.setMany([MatchState.NotStarted, MatchState.Ongoing], [{
      type: SvsViewType.Analyze,
      provider: ContentProvider.Svs
    }]);
  }).build();
  const newMenuItems = [...menuItems.slice(0, 1), ...analyzeMenuItems[matchState], ...menuItems.slice(1)];
  const newContent = _objectSpread(_objectSpread({}, content), Object.keys(analyzeContent).reduce((acc, key) => {
    if (analyzeContent[key][matchState]) {
      acc[key] = analyzeContent[key][matchState];
    }
    return acc;
  }, {}));
  return {
    menuItems: newMenuItems,
    content: newContent
  };
};
setGlobal('svs.components.sportinfo.configs.InjectTab', {
  injectAnalyze
});

 })(window);